module.exports = __webpack_public_path__ + "media/images/partner/baecher_bergmann-ff909cd68986cede67ead09772b0cba9.png";